
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-certified",
      function () {
        return require("private-next-pages/get-certified/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-certified"])
      });
    }
  